import Phaser from "phaser";

import { usePlayerStore } from "../../state/usePlayerStore";
import { getMasterAudioContext, unlockAudioContexts } from "../../lib/audioUnlock";
import type { MountContext, MountedGame } from "../registry";
import { BootScene } from "./scenes/BootScene";
import { PlayScene } from "./scenes/PlayScene";
import { UIScene } from "./scenes/UIScene";

export function mountRetteAnna(
  container: HTMLElement,
  ctx: MountContext,
): MountedGame {
  // Master-AudioContext (idR. schon beim ersten User-Tap erzeugt + entsperrt)
  // an Phaser durchreichen. Sonst legt Phaser einen eigenen Context an, der
  // auf iOS suspended bleibt – mit der Folge, dass SFX erst hörbar werden,
  // sobald `getUserMedia` (Voice-Chat) den System-Audio-Mode aktiviert.
  // Wir versuchen zusätzlich nochmal zu entsperren, falls der User direkt
  // aus der Lobby ins Spiel springt – der „Spiel starten"-Klick gilt dabei
  // als gültige Geste.
  unlockAudioContexts();
  const masterCtx = getMasterAudioContext();

  const game = new Phaser.Game({
    type: Phaser.AUTO,
    parent: container,
    width: container.clientWidth || window.innerWidth,
    height: container.clientHeight || window.innerHeight,
    backgroundColor: "#101428",
    pixelArt: false,
    scale: {
      mode: Phaser.Scale.RESIZE,
      autoCenter: Phaser.Scale.CENTER_BOTH,
    },
    physics: {
      default: "arcade",
      arcade: {
        gravity: { x: 0, y: 1200 },
        debug: false,
      },
    },
    audio: masterCtx ? { context: masterCtx } : undefined,
    scene: [BootScene, PlayScene, UIScene],
  });

  // Spieler-Identität in die globale Phaser-Registry legen, damit alle
  // Scenes sie ohne weitere Props lesen können.
  const state = usePlayerStore.getState();
  game.registry.set("playerName", state.name);
  game.registry.set("playerId", state.id ?? "");
  game.scene.start("BootScene", { ctx });

  return {
    destroy() {
      game.destroy(true);
    },
  };
}
